import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SelectedItemState<MapItemType> {
    public mapItem$: Observable<MapItemType | null>;

    public showDetailView$: Observable<boolean>;

    private readonly _mapItem$ = new BehaviorSubject<MapItemType | null>(null);

    private readonly _showDetailView$ = new BehaviorSubject<boolean>(false);

    constructor() {
        this.mapItem$ = this._mapItem$.asObservable();
        this.showDetailView$ = this._showDetailView$.asObservable();
    }

    public setMapItem(mapItem: MapItemType | null): void {
        this._mapItem$.next(mapItem);

        if (!mapItem) {
            this.setShowDetailView(false);
        }
    }

    public setShowDetailView(showDetailView: boolean): void {
        this._showDetailView$.next(showDetailView);
    }

    public getMapItem(): MapItemType | null {
        return this._mapItem$.value;
    }
}
